export default __webpack_public_path__ + "static/assets/emptyStateIcon.4a4c8382.png";